"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _hooks = require("@kzui/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("../icon/index"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * @description 图片展示组件
 */


var ImageCard = function ImageCard(props) {
  var clsPrefix = 'kui-image-card';
  var className = props.className,
      style = props.style,
      url = props.url;
  var cls = (0, _classnames["default"])(clsPrefix, className);
  var imageStyle = {
    width: '104px',
    height: '104px',
    objectFit: 'cover'
  };
  var ref = (0, React.useRef)(null);
  var hover = (0, _hooks.useHover)(ref);

  function handleDelete() {
    var _props$onDelete;

    props === null || props === void 0 ? void 0 : (_props$onDelete = props.onDelete) === null || _props$onDelete === void 0 ? void 0 : _props$onDelete.call(props);
  }

  function handleEdit() {
    var _props$onEdit;

    props === null || props === void 0 ? void 0 : (_props$onEdit = props.onEdit) === null || _props$onEdit === void 0 ? void 0 : _props$onEdit.call(props);
  }

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cls,
    style: style
  }, /*#__PURE__*/React.createElement("img", {
    className: "".concat(clsPrefix, "-thumb"),
    style: imageStyle,
    src: url
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-cover"),
    style: {
      display: hover ? 'block' : 'none'
    }
  }, props.onEdit ? /*#__PURE__*/React.createElement(_index["default"], {
    onClick: handleEdit,
    className: "".concat(clsPrefix, "-edit"),
    type: "edit"
  }) : null, /*#__PURE__*/React.createElement(_index["default"], {
    onClick: handleDelete,
    className: "".concat(clsPrefix, "-delete"),
    type: "delete"
  })));
};

ImageCard.defaultProps = {
  url: '',
  onDelete: function onDelete() {
    return null;
  },
  style: {}
};
var _default = ImageCard;
exports["default"] = _default;